import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppSettings } from './app/Library/AppSettings';
import { MasterDataService } from './app/Services/MasterDataService';
import { PMSService } from './app/Services/PMSService';
import { PMSSignalRService } from './app/Services/PMSSignalRService';
import { ComplainSignalRService } from './app/Services/ComplainSignalRService';
import { MessagingService } from './app/Services/MessagingService';
import { MessagingSignalRService } from './app/Services/MessagingSignalRService';
import { SessionsSignalRService } from './app/Services/SessionsSignalRService';
import { UserService } from './app/Services/UserService';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.log(err));
